@if (showLogin) {
  <app-auth-shell
    [showCertificateCallback]="showCertificateCallback"
    [showIrrigatorAuth]="showIrrigatorAuth"
    [showGuardAuth]="showGuardAuth"
    [showManagerAuth]="showManagerAuth"
    [certificateCallbackError]="certificateCallbackError"
    [certificateCallbackLoading]="certificateCallbackLoading"
    [loginOptions]="loginOptions"
    [profileIconPaths]="profileIconPaths"
    (certificateBackRequested)="returnToIrrigatorAuth()"
    (profileSelected)="enterAs($event)"
    (authenticated)="startAuthenticatedSessionFromResponse($event)"
    (backToProfileSelectionRequested)="backToProfileSelection()"
  ></app-auth-shell>
} @else {
<main class="shell" [class.authenticated-access]="!isPublicAccess()">
  <app-topbar
    [currentAccessTitle]="currentAccessTitle"
    [currentAccessSubtitle]="currentAccessSubtitle"
    [profileThumbnailPath]="getProfileThumbnailPath()"
    [isPublicAccess]="isPublicAccess()"
    [mobileMenuVisible]="mobileMenuVisible"
    [(cadastralReferenceSearch)]="cadastralReferenceSearch"
    (cadastralReferenceSearchScheduled)="scheduleCadastralReferenceSearch()"
    (mobileMenuOpened)="openMobileMenu()"
    (profileSelectionOpened)="openProfileSelection($event)"
  ></app-topbar>
  <div
    class="app-body"
    [class.public-access]="isPublicAccess()"
    [class.irrigator-access]="isIrrigatorAccess()"
    [class.guard-access]="isGuardAccess()"
    [class.manager-access]="isManagerAccess()"
  >
    <app-sidebar-menu
      [profile]="currentProfile"
      [irrigatorParcelsPanelVisible]="irrigatorParcelsPanelVisible"
      [irrigatorParcels]="irrigatorParcels"
      [irrigatorParcelsLoading]="irrigatorParcelsLoading"
      [irrigatorParcelsError]="irrigatorParcelsError"
      [selectedIrrigatorParcelId]="selectedIrrigatorParcelId"
      [guardTakesPanelVisible]="guardTakesPanelVisible"
      [guardTakes]="guardTakes"
      [guardTakesLoading]="guardTakesLoading"
      [guardTakesError]="guardTakesError"
      [selectedGuardTakeId]="selectedGuardTakeId"
      [guardFieldOperationsView]="guardFieldOperationsView"
      [incidentsSummaryVisible]="incidentsSummaryVisible"
      [maintenanceSummaryVisible]="maintenanceSummaryVisible"
      [publicInfoVisible]="publicInfoVisible"
      [aboutRamVisible]="aboutRamVisible"
      (informationToggled)="togglePublicInformation()"
      (aboutRequested)="showAboutRam()"
      (irrigatorParcelsPanelToggled)="toggleIrrigatorParcelsPanel()"
      (irrigatorParcelSelected)="selectIrrigatorParcel($event)"
      (guardTakesPanelToggled)="toggleGuardTakesPanel()"
      (guardTakeSelected)="selectGuardTake($event)"
      (guardFieldOperationsRequested)="toggleGuardFieldOperationsSummary($event)"
      (logoutRequested)="returnToLogin($event)"
    ></app-sidebar-menu>
    <section
      class="map-wrapper"
      [class.feature-info-active]="featureInfoActive"
      [class.guard-point-selection-active]="guardFieldPointSelectionActive"
    >
      <div #mapHost class="map"></div>

      @if (deploymentNoticeVisible) {
        <aside class="deployment-notice" role="status" aria-labelledby="deployment-notice-title">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 3 2.5 20h19L12 3Z" />
            <path d="M12 9v5" />
            <path d="M12 17.5h.01" />
          </svg>
          <div>
            <strong id="deployment-notice-title">Aviso</strong>
            <p>El Visor, de reciente implantación, continuará incorporando mejoras y nuevas funcionalidades. Si encuentra alguna incidencia, contacte con nuestras oficinas. Disculpen las molestias.</p>
          </div>
          <button type="button" (click)="closeDeploymentNotice()" aria-label="Cerrar aviso">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </aside>
      }

      <app-layer-control
        [layers]="getAvailableRamLayers()"
        [grouped]="isGuardAccess() || isIrrigatorAccess() || isManagerAccess()"
        [(visible)]="layersPanelVisible"
        [featureInfoActive]="featureInfoActive"
        (featureInfoActiveChange)="setFeatureInfoActive($event)"
        (zoomInRequested)="zoomIn()"
        (zoomOutRequested)="zoomOut()"
        (layerToggled)="toggleRamLayer($event.layer, $event.enabled)"
      ></app-layer-control>

      @if (isPublicAccess()) {
        <app-public-access-overlays
          [publicInfoVisible]="publicInfoVisible"
          [aboutRamVisible]="aboutRamVisible"
          (publicInformationToggled)="togglePublicInformation()"
          (aboutRamClosed)="closeAboutRam()"
        ></app-public-access-overlays>
      }
      @if (isIrrigatorAccess()) {
        <app-irrigator-access-overlays
          (parcelsPanelRequested)="showIrrigatorParcelsPanel()"
        ></app-irrigator-access-overlays>
      }
      @if (popupVisible) {
        @if (featureInfoPanelData) {
          <app-feature-info-panel
            [data]="featureInfoPanelData"
            [guardTake]="selectedGuardTake"
            [guardTakeStatusSaving]="guardTakeStatusSaving"
            [guardTakeStatusError]="guardTakeStatusError"
            (guardTakeStatusChangeRequested)="updateGuardTakeStatus($event)"
            (closed)="closePopup()"
          />
        }
      }
      @if (isGuardAccess() || isManagerAccess()) {
        <app-guard-field-operations
          [access]="isManagerAccess() ? 'manager' : 'guard'"
          [activeView]="guardFieldOperationsView"
          [takes]="guardTakes"
          [selectedGuardTakeId]="selectedGuardTakeId"
          [selectedMapPoint]="guardSelectedMapPoint"
          [detectedMapElements]="guardDetectedMapElements"
          [pointSelectionActive]="guardFieldPointSelectionActive"
          [geolocationLoading]="guardGeolocationLoading"
          [geolocationError]="guardGeolocationError"
          [incidentsSummaryVisible]="incidentsSummaryVisible"
          [maintenanceSummaryVisible]="maintenanceSummaryVisible"
          (activeViewChange)="setGuardFieldOperationsView($event)"
          (summaryVisibilityChange)="setGuardFieldSummaryVisibility($event)"
          (sessionExpired)="handleGuardSessionExpired()"
          (statusChanged)="status = $event"
          (pointSelectionRequested)="beginGuardFieldPointSelection()"
          (geolocationRequested)="useGuardCurrentLocation()"
          (pointSelectionCancelled)="cancelGuardFieldPointSelection()"
          (pointResetRequested)="resetGuardSelectedMapPoint()"
        />
      }

    </section>
  </div>

  <app-site-footer />

  @if (mobileMenuVisible) {
    <app-mobile-menu
      [profile]="currentProfile"
      [irrigatorParcelsPanelVisible]="irrigatorParcelsPanelVisible"
      [irrigatorParcels]="irrigatorParcels"
      [irrigatorParcelsLoading]="irrigatorParcelsLoading"
      [irrigatorParcelsError]="irrigatorParcelsError"
      [selectedIrrigatorParcelId]="selectedIrrigatorParcelId"
      [guardTakesPanelVisible]="guardTakesPanelVisible"
      [guardTakes]="guardTakes"
      [guardTakesLoading]="guardTakesLoading"
      [guardTakesError]="guardTakesError"
      [selectedGuardTakeId]="selectedGuardTakeId"
      [guardFieldOperationsView]="guardFieldOperationsView"
      [incidentsSummaryVisible]="incidentsSummaryVisible"
      [maintenanceSummaryVisible]="maintenanceSummaryVisible"
      [publicInfoVisible]="publicInfoVisible"
      [aboutRamVisible]="aboutRamVisible"
      (informationToggled)="togglePublicInformation()"
      (aboutRequested)="showAboutRam()"
      (irrigatorParcelsPanelToggled)="toggleIrrigatorParcelsPanel()"
      (irrigatorParcelSelected)="selectIrrigatorParcel($event)"
      (guardTakesPanelToggled)="toggleGuardTakesPanel()"
      (guardTakeSelected)="selectGuardTake($event)"
      (guardFieldOperationsRequested)="toggleMobileGuardFieldOperationsSummary($event)"
      (logoutRequested)="returnToLogin($event)"
      (closed)="closeMobileMenu()"
    ></app-mobile-menu>
  }
</main>
}
